
<template>
    
        <mars-view v-if="recommendList && recommendList.length" class="relevant-case-container"><mars-view class="case-title">相关推荐</mars-view><template><template v-if="aspH5Data && aspH5Data.wapqbmarketing && aspH5Data.wapqbmarketing.ad_place_data"><mars-view v-for="(item, index) in aspH5Data.wapqbmarketing.ad_place_data" :key="`ad-1929-${index}`" id="ad-area-top" class="ad-area-1059" data-area="ad-1929" data-serverid="17017" @click.native.stop="adClick(0)"><law-ad-h5 :ads-data="aspH5Data" :start-index="index" :end-index="index + 1"></law-ad-h5></mars-view><mars-view class="line"></mars-view></template></template><mars-view v-for="(recommendInfo, index) in recommendList" :key="index" class="recommend-list-box"><template v-if="index === 0"><lawyer-recommend-card :recommend-vip-lawyer="recommendVipLawyerInfo.list || []" :primary-area="recommendVipLawyerInfo.primary_area" position="middle-card" from="regulation_recommend" :server-id="17017"></lawyer-recommend-card><mars-view class="line"></mars-view></template><case-item v-if="!recommendInfo.module" :id="'regulation-recommend-' + index" :case-info="recommendInfo" data-area="xgtj_show" data-serverid="17017" :data-extswan="{
                index,
                qid: recommendInfo.ask && recommendInfo.ask.qid,
                uk: recommendInfo.lawyerInfo && recommendInfo.lawyerInfo.uk,
            }" :data-ext="JSON.stringify({
                index,
                qid: recommendInfo.ask && recommendInfo.ask.qid,
                uk: recommendInfo.lawyerInfo && recommendInfo.lawyerInfo.uk,
            })"></case-item><template><mars-view v-if="adsH5Change && adsH5Change.wapyouxchangeasp && adsH5Change.wapyouxchangeasp.ad_place_data
                    && (index + 1) % 3 === 0 && (index + 1) / 3 <= adsH5Change.wapyouxchangeasp.ad_place_data.length" :id="'regulation-recommend-list-ad-' + (((index + 1) / 3) - 1)" data-area="ad-1930" data-serverid="17017" class="legal-case-ad-area" @click.native.stop="adClick(1)"><mars-view v-if="recommendList.length !== index + 1" class="line"></mars-view><mars-view><law-ad-h5-case-list :ads-h5-change-item="{
                            ad_place_data: adsH5Change.wapyouxchangeasp.ad_place_data[((index + 1) / 3) - 1],
                            ad_place_js: adsH5Change.wapyouxchangeasp.ad_place_js,
                            ad_place_css: adsH5Change.wapyouxchangeasp.ad_place_css,
                        }"></law-ad-h5-case-list></mars-view></mars-view></template><mars-view v-if="recommendList.length !== index + 1" class="line"></mars-view><template v-if="index === 3"><lawyer-recommend-card :recommend-vip-lawyer="recommendVipLawyerInfo.recommend_list || []" :primary-area="recommendVipLawyerInfo.primary_area" position="related-list-card" from="lawregulation_recommend" :server-id="17017"></lawyer-recommend-card><mars-view class="line"></mars-view></template></mars-view></mars-view>
    
</template>

<script>
import caseItem from "./case-item.vue";
import LawyerRecommendCard from "../../../pages/qalandpage/iknow/lawyer-recommend-card.vue";
import LawAdH5 from "../../../pages/qalandpage/iknow/law-ad-h5.vue";
import LawAdH5CaseList from "../../../pages/qalandpage/iknow/law-ad-h5-case-list.vue";
import { inSightObservers } from '../../../common/js/repeatExposureLog.js';
import log from '../../../static/utils/ubcLog';
import { adAreaMap } from '../utils/commonData';
export default {
  components: {
    'case-item': caseItem,
    'lawyer-recommend-card': LawyerRecommendCard,
    'law-ad-h5': LawAdH5,
    'law-ad-h5-case-list': LawAdH5CaseList
  },
  props: {
    // 推荐列表
    recommendList: {
      type: Array,
      default() {
        return [];
      }
    },
    // 1059广告
    aspChangeData: {
      type: Array,
      default() {
        return [];
      }
    },
    // 广告
    aspFeedData: {
      type: Array,
      default() {
        return [];
      }
    },
    // 标识问题来源
    importId: {
      type: Number,
      default: 0
    },
    // 标题
    title: {
      type: String,
      default: ''
    },
    // 律师推荐
    recommendVipLawyerInfo: {
      type: Object,
      default() {
        return {};
      }
    },
    lawAdSwitch: {
      type: Object,
      default() {
        return {};
      }
    },
    adsH5Change: {
      type: Object,
      default() {
        return {};
      }
    },
    aspH5Data: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.recommendList && this.recommendList.length && this.recommendList.forEach((item, index) => {
          inSightObservers.call(this, `#regulation-recommend-${index}`, '', {}, [], false, true, true, {
            threshold: 0.99
          });
        });
      }, 500);
    });
    this.adShowLog();
  },
  methods: {
    adShowLog() {
      if (!this.adsH5Change || !this.adsH5Change.wapyouxchangeasp) {
        this.adShowTimeout = setTimeout(() => {
          clearTimeout(this.adShowTimeout);
          this.adShowTimeout = null;
          this.adShowLog();
        }, 1500);
        return;
      }
      this.$nextTick(() => {
        setTimeout(() => {
          inSightObservers.call(this, '#ad-area-top', '', {}, [], false, true, true, {
            threshold: 0.3
          });
        }, 1500);
      });
      this.$nextTick(() => {
        setTimeout(() => {
          for (let i = 0; i < 7; i++) {
            inSightObservers.call(this, '#regulation-recommend-list-ad-' + i, '', {}, [], false, true, true, {
              threshold: 0.5
            });
          }
        }, 1500);
      });
    },
    adClick(index) {
      log.send && log.send({
        serverId: 17017,
        area: 'gg_click',
        action: 'click'
      });
      adAreaMap[+index] && log.send && log.send({
        serverId: 16866,
        area: adAreaMap[+index],
        action: 'click'
      });
    }
  }
};
</script>

<style scoped>
.relevant-case-container {
  margin-top: 1.93vw;
  padding-top: 4.83vw;
  background-color: #fff;
}
.relevant-case-container .case-title {
  font-family: PingFang SC;
  font-size: 4.59vw;
  color: #1e1f24;
  line-height: 4.59vw;
  font-weight: 700;
  padding: 0 4.11vw;
}
.relevant-case-container .line {
  margin: 0 4.11vw;
  border-bottom: 0.16vw solid #edeef0;
}

</style>
